export default "__VITE_ASSET__DDR1odQ3__"